var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "call",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27748",
    "data-name": "Path 27748",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27749",
    "data-name": "Path 27749",
    d: "M6.3,4.867a11.492,11.492,0,0,0,.42,2.417L5.6,8.4a13.837,13.837,0,0,1-.709-3.537H6.3m9.2,11.219a11.9,11.9,0,0,0,2.427.42V17.9a14.4,14.4,0,0,1-3.547-.7l1.12-1.111M7.2,3H3.933A.936.936,0,0,0,3,3.933,15.865,15.865,0,0,0,18.867,19.8a.936.936,0,0,0,.933-.933V15.609a.936.936,0,0,0-.933-.933,10.647,10.647,0,0,1-3.332-.532.784.784,0,0,0-.289-.047.956.956,0,0,0-.663.271l-2.053,2.053a14.139,14.139,0,0,1-6.151-6.151L8.432,8.217a.937.937,0,0,0,.233-.952,10.6,10.6,0,0,1-.532-3.332A.936.936,0,0,0,7.2,3Z",
    transform: "translate(0.6 0.6)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.fb1b525d0065805083042ace79d7f084.svg";
export { ForwardRef as ReactComponent };